export default {"src":"/_next/static/media/bikeAccessories_40.4aceed90.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};